import React, { useEffect, useState } from "react"
import { MAIN_ROUTES } from "routes/routes"
import { map, findKey, get, compact } from "lodash"
import store from "redux/store"
import { cancelLoad } from "redux/ducks/PageLoad"
import { Link } from "react-router-dom"
import ClassNames from "classnames"
import { Labels } from "components/atoms/input/input"
import { MARKET_CONDITIONS_REPORT_URL, MANUAL_URL } from "config/const"

const NEWS_ID = 3
const colorTypeList = [{ name: "黒", id: 0 }, { name: "白", id: 1 }]
export const loadTypeList = [{ name: "自動", id: 0 }, { name: "手動", id: 1 }]

const SpHamburgerMenu = (props: {
  visible: boolean
  setVisible: Function
  colorType: number
  changeColorType: Function
  changeLoad: Function
  isAutoLoad: number
  location: string
}) => {
  const {
    visible,
    setVisible,
    colorType,
    changeColorType,
    isAutoLoad,
    changeLoad,
    location,
  } = props
  const [selectedTab, setSelectedTab] = useState<number | null>(null)
  //選択行にactiveを付与して色を付けるためのステート
  const [mainActiveId, setMainActiveId] = useState<number | null>(null)
  const [subActiveId, setSubActiveId] = useState<number | null>(null)

  const _setSelectedTab = (id: number) => {
    if (selectedTab === id) return setSelectedTab(null)
    setSelectedTab(id)
  }

  const getCurrentPage = () => {
    const _location = compact(location.split("/"))
    const [mainPagePath, subPagePath] = _location
    const mainPageId = Number(
      findKey(MAIN_ROUTES, { path: `/${mainPagePath}` })
    )
    if (mainPageId === 3) {
      setMainActiveId(mainPageId)
      setSubActiveId(null)
    } else {
      const subPageId = Number(
        findKey(get(MAIN_ROUTES[Number(mainPageId)], "routes"), {
          path: `/${mainPagePath}/${subPagePath}`,
        })
      )
      setSelectedTab(mainPageId)
      setMainActiveId(mainPageId)
      setSubActiveId(subPageId)
    }
  }

  useEffect(() => {
    getCurrentPage()
  }, [visible])

  return (
    <div className="sp-menu-accordion-wrapper">
      <div className="sp-menu-pagenation">
        {map(MAIN_ROUTES, (main, main_index: number) => {
          // SP版は銘柄検索を削除する。
          if (main_index === 4) return
          return (
            <React.Fragment key={main_index}>
              <div
                className={ClassNames("sp-menu-accordion", {
                  active: main_index === mainActiveId,
                })}
                onClick={() => {
                  _setSelectedTab(main_index)
                  if (main_index === 3) setVisible()
                }}
              >
                {main_index !== NEWS_ID ? (
                  <div className="sp-menu-accordion-contents">
                    <div className="sp-menu-accordion-items sp-menu-accordion-icon">
                      <i className="material-icons">{main.icon}</i>
                    </div>
                    <div className="sp-menu-accordion-items sp-menu-accordion-title">
                      {main.name}
                    </div>
                    <div className="sp-menu-accordion-items sp-menu-accordion-arrow">
                      <i
                        className={ClassNames("material-icons sort-icon", {
                          active: main_index === selectedTab,
                        })}
                      >
                        keyboard_arrow_down
                      </i>
                    </div>
                  </div>
                ) : (
                  <Link
                    className="sp-menu-accordion-contents"
                    to={main.path}
                    onClick={() => store.dispatch(cancelLoad())}
                  >
                    <div className="sp-menu-accordion-items sp-menu-accordion-icon">
                      <i className="material-icons">{main.icon}</i>
                    </div>
                    <div className="sp-menu-accordion-items sp-menu-accordion-title">
                      {main.name}
                    </div>
                  </Link>
                )}
              </div>
              {main_index === selectedTab && (
                <ul className="sp-menu-sub-contents">
                  <div
                    className={ClassNames("background-title", {
                      register: main_index === 5,
                    })}
                  />
                  {map(
                    get(MAIN_ROUTES, [main_index, "routes"]),
                    (sub, sub_index) => {
                      return (
                        <li key={sub_index} className="sp-menu-sub">
                          <Link
                            to={sub.path}
                            onClick={() => {
                              setSubActiveId(sub_index)
                              setMainActiveId(main_index)
                              store.dispatch(cancelLoad())
                              setVisible()
                            }}
                            className={ClassNames("sp-menu-sub-item", {
                              active:
                                mainActiveId === selectedTab &&
                                subActiveId === sub_index,
                            })}
                          >
                            <i className="material-icons">
                              fiber_manual_record
                            </i>
                            <span className="sp-menu-sub-title">
                              {sub.name}
                            </span>
                          </Link>
                        </li>
                      )
                    }
                  )}
                </ul>
              )}
            </React.Fragment>
          )
        })}
        <div
          className="sp-menu-accordion"
          onClick={() => {
            _setSelectedTab(6)
          }}
        >
          <div className="sp-menu-accordion-contents">
            <div className="sp-menu-accordion-items sp-menu-accordion-icon">
              <i className="material-icons">settings</i>
            </div>
            <div className="sp-menu-accordion-items sp-menu-accordion-title">
              設定
            </div>
            <div className="sp-menu-accordion-items sp-menu-accordion-arrow">
              <i
                className={ClassNames("material-icons sort-icon", {
                  active: selectedTab === 6,
                })}
              >
                keyboard_arrow_down
              </i>
            </div>
          </div>
        </div>
        {selectedTab === 6 && (
          <ul className="sp-menu-sub-contents">
            <div className={ClassNames("background-title")} />
            <li className="sp-menu-sub">
              <div className="sp-menu-sub-item">
                <i className="material-icons">fiber_manual_record</i>
                <span className="sp-menu-sub-title">テーマ切替</span>
                <div
                  className="theme-btn"
                  onClick={() => {
                    if (colorType) {
                      changeColorType(0)
                    } else {
                      changeColorType(1)
                    }
                  }}
                />
              </div>
            </li>
            <li className="sp-menu-sub">
              <div className="sp-menu-sub-item">
                <i className="material-icons">fiber_manual_record</i>
                <span className="sp-menu-sub-title">ページ更新</span>
                <div className="page-update">
                  <Labels
                    className="btn-segmented-control btn-thin liquid-control"
                    labelList={loadTypeList}
                    checked={isAutoLoad}
                    onChange={(id: number) => {
                      changeLoad(id)
                    }}
                  />
                </div>
              </div>
            </li>
          </ul>
        )}
        <div
          className="sp-menu-accordion"
          onClick={() => {
            _setSelectedTab(7)
          }}
        >
          <div className="sp-menu-accordion-contents">
            <div className="sp-menu-accordion-items sp-menu-accordion-icon">
              <i className="material-icons">help_outline</i>
            </div>
            <div className="sp-menu-accordion-items sp-menu-accordion-title">
              市況レポート/マニュアル
            </div>
            <div className="sp-menu-accordion-items sp-menu-accordion-arrow">
              <i
                className={ClassNames("material-icons sort-icon", {
                  active: selectedTab === 7,
                })}
              >
                keyboard_arrow_down
              </i>
            </div>
          </div>
        </div>
        {selectedTab === 7 && (
          <ul className="sp-menu-sub-contents">
            <div className="background-title" />
            <li
              className="sp-menu-sub"
              onClick={() => {
                window.open(MARKET_CONDITIONS_REPORT_URL)
              }}
            >
              <div className="sp-menu-sub-item">
                <i className="material-icons">fiber_manual_record</i>
                <span className="sp-menu-sub-title">市況レポート</span>
              </div>
            </li>
            <li
              className="sp-menu-sub"
              onClick={() => {
                window.open(MANUAL_URL)
              }}
            >
              <div className="sp-menu-sub-item">
                <i className="material-icons">fiber_manual_record</i>
                <span className="sp-menu-sub-title">マニュアル</span>
              </div>
            </li>
          </ul>
        )}
        <div className="sp-menu-accordion stretch" />
      </div>
    </div>
  )
}

export default SpHamburgerMenu
